/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Footer_TopInputs */

const en_road_dude_footer_top = /** @type {(inputs: Road_Dude_Footer_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back to top`)
};

const zh_road_dude_footer_top = /** @type {(inputs: Road_Dude_Footer_TopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回到顶部`)
};

/**
* | output |
* | --- |
* | "Back to top" |
*
* @param {Road_Dude_Footer_TopInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_footer_top = /** @type {((inputs?: Road_Dude_Footer_TopInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Footer_TopInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_footer_top(inputs)
	return zh_road_dude_footer_top(inputs)
});
export { road_dude_footer_top as "road_dude.footer.top" }